// Single source of truth for the white-label build flag. Vite inlines
// `import.meta.env.VITE_WHITE_LABEL` at build time. Normalises whitespace
// and casing so a stray "true " in .env still evaluates correctly, and
// defaults to false when the variable is missing entirely.
export const isWhiteLabel = () => {
  const raw = import.meta.env.VITE_WHITE_LABEL;
  if (raw === true) return true;
  if (typeof raw !== "string") return false;
  return raw.trim().toLowerCase() === "true";
};

// White label mock test title constant
export const WHITE_LABEL_MOCK_TITLE = "PTEMax ";

// White label logo path constant
export const WHITE_LABEL_DEFAULT_LOGO_PATH = "/assets/img/20logo.png";

// Resolve the partner subdomain from the current host. Shape is
// `[www.]<subdomain>.<base>`, where <base> is "localhost" in dev or
// "<domain>.<tld>" in prod — e.g. www.softude.localhost → "softude",
// softude.20task.com → "softude". A leading "www" is stripped (so login and
// every other request send "softude", never "www"), and the partner label is
// returned only when one actually sits in front of the base domain; otherwise
// null (no partner subdomain → callers should send nothing).
export const getSubdomain = () => {
  if (typeof window === "undefined" || !window.location) return null;
  const parts = window.location.hostname.split(".");
  if (parts[0] === "www") parts.shift();
  const baseLen = parts[parts.length - 1] === "localhost" ? 1 : 2;
  return parts.length > baseLen ? parts[0] : null;
};
